<template>
    <div id="app">
        <canvas :id="index" height="50" width="50"></canvas>
    </div>
</template>
<script>
import paper from "paper";
export default {
    name: "canvasItem",
    props: ["pinColor", "icon", "index"],

    mounted() {
        this.makeCanvas();
    },

    watch: {
        image: [
            {
                handler: "makeCanvas"
            }
        ],
        pinColor: [
            {
                handler: "makeCanvas"
            }
        ],
        icon: [
            {
                handler: "makeCanvas"
            }
        ]
    },
    methods: {
        makeCanvas() {
            let canvas = document.getElementById(this.index);
            paper.setup(canvas);

            let image = require(`../../../public/img/icon/${this.icon}.svg`);
            let color = this.pinColor;

            paper.project.importSVG(image, function(item) {
                item.fillColor = color;
                item.scale(0.15, item.bounds.topLeft);
                paper.project.view.update();
            });
        }
    }
};
</script>
